<script>
    import Fa from 'svelte-fa';
    import { faArrowRight, faArrowLeft, faBell } from '@fortawesome/pro-regular-svg-icons';

    import { page } from '$app/stores';

    import AccountOrderList from '$lib/components/AccountOrderList.svelte';
    import PageHeader from '$lib/components/PageHeader.svelte';
    import WebPushPrompt from '$lib/components/WebPushPrompt.svelte';
    import Modal from '$lib/components/Modal.svelte';

    export let data;

    $: orders = data?.customer?.orders?.edges;
    $: pageInfo = data?.customer?.orders?.pageInfo;

    // pagination buttons for bots
    const pagination = (direction) => {
        // create href for page nav buttons
        const searchParams = new URLSearchParams($page.url.search);

        switch (direction) {
            case 'next':
                searchParams.delete('before');
                searchParams.set('after', pageInfo?.endCursor);
                break;
            case 'prev':
                searchParams.delete('after');
                searchParams.set('before', pageInfo?.startCursor);
                break;
        }

        return `${$page.url.pathname}?${searchParams.toString()}`;
    };

    $: openWebPushPrompt = true;
</script>

<svelte:head>
    <title>My Orders | Caktus Vape</title>
</svelte:head>

<div class="container px-1">
    <PageHeader title="My Orders" userButton={true} classes="px-2 py-8 lg:px-0" />

    <div class="m-auto max-w-3xl">
        {#if data?.errors?.length}
            {#each data.errors as error}
                {error?.message}
            {/each}
        {/if}

        <div class="grid grid-cols-1 gap-4 lg:m-auto lg:max-w-5xl lg:grid-cols-1">
            {#if orders?.length}
                {#each orders as order, index (order)}
                    {#if index === 0 && !pageInfo?.hasPreviousPage}
                        <h2 class="pl-2 text-lg font-semibold">Latest Order</h2>
                    {/if}

                    <AccountOrderList order={order?.node} featureOrder={index === 0 && !pageInfo?.hasPreviousPage ? true : false} />

                    {#if index === 0 && !pageInfo?.hasPreviousPage && orders?.length > 1}
                        <h2 class="mt-8 pl-2 text-lg font-semibold">Past Orders</h2>
                    {/if}
                {/each}
            {:else}
                <div
                    class="m-4 flex aspect-square max-w-lg flex-col justify-evenly rounded-2xl border-4 border-dashed border-color-text/20 p-6 shadow-sm lg:mx-auto"
                >
                    <img alt="Caktus Logo" src="/svg/CaktusEmblem.svg" class="mx-auto block h-28 w-28 dark:invert" />

                    <div class="flex flex-col items-center gap-4 p-4 text-center">
                        <h2 class="text-xl font-semibold dark:text-purple-300">This is your orders page</h2>
                        <p>
                            You can easily keep tabs on your orders from here. Track every step from start to finish and you can even reorder products from your
                            previous purchases.
                        </p>
                    </div>
                    <a class="btn inline-block w-full bg-primary bg-none text-base capitalize" href="/">Go Shopping</a>
                </div>
            {/if}
        </div>

        {#key $page}
            {#if pageInfo?.hasNextPage || pageInfo?.hasPreviousPage}
                <div class="grid grid-cols-2 py-4 lg:m-auto lg:max-w-5xl">
                    <div class="m-2 text-right lg:text-left">
                        {#if pageInfo?.hasPreviousPage}
                            <a href={pagination('prev')} class="inline-block rounded-xl bg-primary px-4 py-3 text-center font-semibold text-white"
                                ><Fa icon={faArrowLeft} class="inline-block" /></a
                            >
                        {:else}
                            <span class="inline-block rounded-xl bg-base-700 px-4 py-3 text-center font-semibold text-white"
                                ><Fa icon={faArrowLeft} class="inline-block" /></span
                            >
                        {/if}
                    </div>
                    <div class="m-2 text-left lg:text-right">
                        {#if pageInfo?.hasNextPage}
                            <a href={pagination('next')} class="inline-block rounded-xl bg-primary px-4 py-3 text-center font-semibold text-white"
                                ><Fa icon={faArrowRight} class="inline-block" /></a
                            >
                        {:else}
                            <span class="inline-block rounded-xl bg-base-700 px-4 py-3 text-center font-semibold text-white"
                                ><Fa icon={faArrowRight} class="inline-block" /></span
                            >
                        {/if}
                    </div>
                </div>
            {/if}
        {/key}
    </div>
</div>

<WebPushPrompt let:browserPermission let:nativePushPrompt let:remindMeLater>
    {#if browserPermission !== 'denied'}
        <Modal bind:modalOpen={openWebPushPrompt} name="WebPushPrompt">
            <div class="m-auto flex min-h-80 max-w-sm flex-col items-center justify-center gap-8 text-center">
                <Fa icon={faBell} size="3x" />
                <div>
                    <h2 class="text-xl font-semibold">Get real-time tracking notifications!</h2>
                    <p class="text-xs">Allow push notifications to receive real-time updates!</p>
                </div>
                <button
                    class="w-full rounded-xl bg-primary p-3.5 text-center text-base font-semibold text-white shadow-xl"
                    on:click={() => {
                        nativePushPrompt();
                        openWebPushPrompt = false;
                    }}>Yes, Allow</button
                >
                <button
                    class="mt-4 w-full text-center opacity-50"
                    on:click={() => {
                        remindMeLater();
                        openWebPushPrompt = false;
                    }}>Maybe later</button
                >
            </div>
        </Modal>
    {/if}
</WebPushPrompt>
